import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import NewCampaign from './NewCampaign';
import EditCampaign from './EditCampaign';
import Participants from './Participants';

class Container extends Component {
  render() {
    return (
      <div id="giveaway">
        <Route exact path="/giveaway" component={List} />
        <Route exact path="/giveaway/new" component={NewCampaign} />
        <Route exact path="/giveaway/:id/edit" component={EditCampaign} />
        <Route exact path="/giveaway/:id/participants" component={Participants} />
      </div>
    );
  }
}

export default Container;
